import type { Element } from "React";
import { FormattedMessage } from "react-intl";
type Props = {
  className?: string;
};

const IconBookmark = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={props.className}
  >
    <title id="title">
      <FormattedMessage tagName="span" id="events-bookmarks" />
    </title>
    <path d="M6.5 2.5v18l5.5-7.333 5.5 7.333v-18h-11z" />
  </svg>
);

export default IconBookmark;
